import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { ArrowRight } from "lucide-react";

export default function ServiceCard({ service, showImage = true }) {
  const Icon = Icons[service.icon] || Icons.FileText;
  return (
    <Link
      to={`/services/${service.slug}`}
      data-testid={`service-card-${service.slug}`}
      className="card-hover group flex flex-col overflow-hidden rounded-xl border border-slate-200 bg-white"
    >
      {showImage && service.image && (
        <div className="relative h-40 overflow-hidden">
          <img
            src={service.image}
            alt={service.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute -bottom-5 left-5 flex h-11 w-11 items-center justify-center rounded-full bg-navy text-gold shadow-lg ring-4 ring-white">
            <Icon size={20} />
          </div>
        </div>
      )}
      <div className={`flex flex-1 flex-col p-6 ${showImage ? "pt-8" : ""}`}>
        {!showImage && (
          <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-full bg-navy text-gold">
            <Icon size={20} />
          </div>
        )}
        <h3 className="font-serif text-xl font-semibold text-navy">{service.title}</h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{service.short_desc}</p>
        <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-gold">
          View service
          <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
}
